import React from "react";
import Link from "next/link";

import Button from "components/botanic/Button";
import NotFoundIcon from "components/Icons/not_found.svg";

type Props = {
  onButtonClick: () => void;
};

const AllBrandsEmptyState: React.FC<Props> = ({ onButtonClick }) => {
  return (
    <div className="border border-light-grey rounded flex flex-col items-center gap-lg p-lg">
      <div className="flex flex-col items-center gap-md">
        <NotFoundIcon width={48} />
        <h1 className="font-bold text-md text-center">No results found</h1>
      </div>
      <p className="mb-none text-center">
        Try searching another brand name or request this brand on Leafly
      </p>
      <Button
        data-testid="back-to-all-brands-button"
        onClick={onButtonClick}
        variant="tertiary"
        className="py-md px-xl w-full md:w-auto"
      >
        <span className="text-sm">back to all brands</span>
      </Button>
      <Link
        className="underline font-bold"
        href="https://success.leafly.com/brand-subscription"
      >
        request brand
      </Link>
    </div>
  );
};

export default AllBrandsEmptyState;
